import { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, ButtonBase, Tooltip, Typography, useMediaQuery } from '@mui/material';

// project-imports
import IconButton from 'components/@extended/IconButton';
import useAuth from 'hooks/useAuth';

import { Logout, MoneyRecive, Crown } from 'iconsax-react';
import { useSelector } from 'react-redux';


const ProfilePage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const { limitBalance , wallet_balance} = useSelector((state) => state?.uploadReducer);
  const [subscriptionPlan, setSubscriptionPlan] = useState('');

  const { logout } = useAuth();

  // Get subscription plan from localStorage
  useEffect(() => {
    try {
      const subscription = localStorage.getItem('subscription');
      setSubscriptionPlan(subscription || 'Free');
    } catch (error) {
      console.error('Error reading subscription from localStorage:', error);
      setSubscriptionPlan('Free');
    }
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      localStorage.clear()
      navigate(`/login`, {
        state: {
          from: ''
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  // Format balance for display
  const formatBalance = (balance) => {
    if (!balance || !balance.current_limit) return '0.00';
    const numBalance = parseFloat(balance.current_limit);
    return numBalance.toFixed(2);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        px: isMobile ? 0.5 : 2,
        py: 0.5,
        minHeight: '48px' 
      }}
    >
      {/* Logout Button - Left Side */}
      <Box
        sx={{
          flexShrink: 0,
          bgcolor: '#ccebff',
          display: 'flex',
          borderRadius: 1,
          p: 0.25,
          order: 1
        }}
      >
        <ButtonBase
          sx={{
            p: 0.25,
            borderRadius: 1,
            '&:hover': { bgcolor: theme.palette.mode === 'dark' ? 'secondary.light' : 'secondary.lighter' },
            '&:focus-visible': {
              outline: `2px solid ${theme.palette.secondary.dark}`,
              outlineOffset: 2
            }
          }}
          aria-label="open profile"
          ref={anchorRef}
          aria-controls={open ? 'profile-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <Tooltip title="Logout">
            <IconButton size={isMobile ? 'medium' : 'large'} color="#001a66" sx={{ p: isMobile ? 0.5 : 1 }} onClick={handleLogout}>
              <Logout variant="Bulk" />
            </IconButton>
          </Tooltip>
        </ButtonBase>
      </Box>

      {/* Right Side Container - Subscription and Balance */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: isMobile ? 0.5 : 1,
          order: 2
        }}
      >
        {/* Subscription Plan Display */}
        {/* <Box
          sx={{
            flexShrink: 0,
            bgcolor: '#f0f8ff',
            display: 'flex',
            alignItems: 'center',
            borderRadius: 1,
            px: isMobile ? 0.75 : 1.5,
            py: 0.5,
            border: '1px solid #c7e3ff',
            minWidth: 'fit-content'
          }}
        >
          <Tooltip title={`Current subscription plan: ${subscriptionPlan}`}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: 'center',
                gap: isMobile ? 0 : 0.5,
                cursor: 'default'
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}
              >
                <Crown size={isMobile ? 14 : isTablet ? 16 : 18} color="#8A2BE2" variant="Bold" />
                <Typography
                  variant={isMobile ? 'caption' : 'body2'}
                  sx={{
                    color: '#001a66',
                    fontWeight: 500,
                    fontSize: isMobile ? '0.6rem' : isTablet ? '0.75rem' : '0.875rem',
                    lineHeight: isMobile ? 1.2 : 1.4,
                    whiteSpace: 'nowrap'
                  }}
                >
                  {isMobile ? 'Plan:' : 'Subscription Plan:'}
                </Typography>
              </Box>
              <Typography
                variant={isMobile ? 'caption' : 'body2'}
                sx={{
                  color: '#001a66',
                  fontWeight: 600,
                  fontSize: isMobile ? '0.65rem' : isTablet ? '0.8rem' : '0.875rem',
                  lineHeight: isMobile ? 1.2 : 1.4,
                  whiteSpace: 'nowrap',
                  textTransform: 'capitalize'
                }}
              >
                {subscriptionPlan}
              </Typography>
            </Box>
          </Tooltip>
        </Box> */}

        {/* Balance Display */}
        <Box
          sx={{
            flexShrink: 0,
            bgcolor: '#e8f4fd',
            display: 'flex',
            alignItems: 'center',
            borderRadius: 1,
            px: isMobile ? 0.75 : 1.5,
            py: 0.5,
            border: '1px solid #b3d9ff',
            minWidth: 'fit-content'
          }}
        >
            <Box
              sx={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: 'center',
                gap: isMobile ? 0 : 0.5,
                cursor: 'default'
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}
              >
                <MoneyRecive size={isMobile ? 14 : isTablet ? 16 : 18} color="#FFD700" variant="Bold" />
                <Typography
                  variant={isMobile ? 'caption' : 'body2'}
                  sx={{
                    color: '#001a66',
                    fontWeight: 500,
                    fontSize: isMobile ? '0.6rem' : isTablet ? '0.75rem' : '0.875rem',
                    lineHeight: isMobile ? 1.2 : 1.4,
                    whiteSpace: 'nowrap'
                  }}
                >
                  {isMobile ? 'Balance:' : 'Wallet Balance:'}
                </Typography>
              </Box>
              <Typography
                variant={isMobile ? 'caption' : 'body2'}
                sx={{
                  color: '#001a66',
                  fontWeight: 600,
                  fontSize: isMobile ? '0.65rem' : isTablet ? '0.8rem' : '0.875rem',
                  lineHeight: isMobile ? 1.2 : 1.4,
                  whiteSpace: 'nowrap'
                }}
              >
                {`$${wallet_balance}`} 
              </Typography>
            </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfilePage;
